import { choosePlatformDomainName, choosePlatformName } from '../helpers/utils';

export const navigateResponsible = [
	{
		icon: 'limits',
		route: '/my-profile/change-selflimits',
		title: 'Limites pessoais',
		description: 'Defina limites pessoais para um jogo responsável.',
	},
	{
		icon: 'lock',
		route: '/my-profile/lock-account',
		title: 'Pausa ou período de afastamento',
		description: 'Clientes podem dar um tempo de jogar a qualquer momento.',
	},
	{
		icon: 'close',
		route: '/my-profile/close-account',
		title: 'Autoexclusão',
		description:
			'Autoexclusão envolve um compromisso conjunto nosso e do cliente.',
	},
];

export const guidelinesResponsible = [
	{
		position: 1,
		title: 'RESPONSABILIDADE PERANTE NOSSOS JOGADORES',
		description: `Valorizamos profundamente nossos jogadores e respeitamos suas expectativas em relação ao entretenimento oferecido pela ${choosePlatformName()}. Nos orgulhamos de ser a plataforma escolhida por nossos usuários para a realização de apostas esportivas e jogos online, e temos o compromisso de garantir uma experiência positiva e segura.`,
	},
	{
		position: 1.1,
		title: 'PREVENÇÃO E PROTEÇÃO',
		description:
			'Estamos comprometidos em proteger o bem-estar de nossos jogadores. Para isso, adotamos medidas preventivas rigorosas para evitar a dependência em jogos e impedir a participação de menores de idade em atividades de apostas, em conformidade com o Artigo 19 da Lei nº 14.790/2023, que proíbe a participação de menores de 18 anos. Utilizamos sistemas avançados de verificação de idade e identidade, e desencorajamos o jogo sob influência de substâncias psicoativas, tristeza ou depressão.',
	},
	{
		position: 1.2,
		title: 'INCENTIVO AO JOGO RESPONSÁVEL E CONTROLE DO USUÁRIO',
		description:
			'Oferecemos ferramentas que permitem aos nossos jogadores manter o controle de suas atividades, incluindo limites de depósito, opções de pausa temporária e autoexclusão. Além disso, disponibilizamos orientação sobre práticas saudáveis de jogo e encaminhamos nossos jogadores a serviços de apoio psicológico e tratamento especializado quando necessário.',
	},
	{
		position: 1.3,
		title: 'SINAIS DE ALERTA E AUTOAVALIAÇÃO',
		description:
			'Fornecemos informações claras sobre sinais de alerta que possam indicar comportamentos problemáticos relacionados ao jogo. Encorajamos a autoavaliação regular do tempo e dinheiro investidos em apostas, como forma de promover a consciência e a prevenção de comportamentos prejudiciais.',
	},
	{
		position: 1.4,
		title: 'MONITORAMENTO E EQUILÍBRIO',
		description:
			'Recomendamos que nossos jogadores monitorem suas atividades de jogo e mantenham o equilíbrio com outras formas de entretenimento. Sugerimos pausas regulares para evitar excessos e promovemos um estilo de vida saudável e equilibrado.',
	},
	{
		position: 1.5,
		title: 'TRANSPARÊNCIA E EDUCAÇÃO',
		description:
			'Promovemos a compreensão das chances reais de ganho, fornecendo informações claras e acessíveis sobre as probabilidades de vitória e os riscos associados às apostas. Também incentivamos a busca por suporte profissional sempre que necessário.',
	},
	{
		position: 1.6,
		title: 'TREINAMENTO DE FUNCIONÁRIOS',
		description:
			'Investimos continuamente na capacitação de nossos colaboradores, para que possam identificar e gerenciar sinais de problemas relacionados ao jogo entre os jogadores. Funcionários bem treinados são essenciais para fornecer suporte adequado e encaminhar os jogadores aos recursos de apoio necessários.',
	},
	{
		position: 1.7,
		title: 'CONFORMIDADE LEGAL',
		description:
			'Cumprimos rigorosamente todas as leis e regulamentações aplicáveis ao setor de jogos online e apostas, incluindo a Lei nº 14.790/2023. Nossa conformidade legal é um reflexo do nosso compromisso com a ética e a responsabilidade, garantindo um ambiente de jogo seguro e regulamentado para todos os nossos jogadores.',
	},
	{
		position: 1.8,
		title: 'FEEDBACK DOS JOGADORES',
		description:
			'Valorizamos o feedback de nossos jogadores sobre a eficácia das políticas de jogo responsável que implementamos. Utilizamos essas informações para ajustar e melhorar continuamente nossas práticas, assegurando que atendemos às necessidades e preocupações de todos.',
	},
	{
		position: 1.9,
		title: 'PARCERIAS COM ORGANIZAÇÕES DE APOIO',
		description:
			'Estabelecemos parcerias com organizações especializadas no tratamento da dependência de jogos para oferecer suporte adicional aos nossos jogadores. Essas parcerias permitem que nossos usuários tenham acesso a recursos atualizados e ajuda profissional de qualidade.',
	},
	{
		position: 2,
		title: 'MECANISMOS DE MONITORAMENTO E CONTROLE',
		description: `A ${choosePlatformName()} implementa uma série de mecanismos de monitoramento e controle para assegurar a aplicação eficaz desta política, tais como:`,
		ulList: [
			{
				liDescription:
					'•	Sistemas de detecção de padrões de jogo problemáticos: Analisamos continuamente o comportamento dos jogadores para identificar possíveis sinais de dependência.',
			},
			{
				liDescription:
					'•	Ferramentas de controle para os jogadores: Limites de depósito, tempo de jogo e perda, além de opções de autoexclusão.',
			},
			{
				liDescription:
					'•	Auditorias internas e externas: Avaliação regular dos nossos processos e sistemas para garantir a conformidade com a legislação vigente.',
			},
		],
	},
	{
		position: 3,
		title: 'ORIENTAÇÕES PARA JOGADORES',
		description:
			'Para promover uma experiência de jogo segura, recomendamos:',
		ulList: [
			{
				liDescription:
					'•	Definir limites de tempo e dinheiro: Estabeleça orçamentos e cronogramas para suas atividades de jogo.',
			},
			{
				liDescription:
					'•	Evitar o jogo como forma de solução de problemas financeiros: O jogo deve ser visto como entretenimento, não como uma forma de renda.',
			},
			{
				liDescription:
					'•	Buscar apoio quando necessário: Caso identifique sinais de comportamento problemático, não hesite em buscar ajuda profissional.',
			},
		],
	},
	{
		position: 4,
		title: 'CONTATO E SUPORTE',
		description:
			'Estamos comprometidos em proporcionar um ambiente de jogo seguro, saudável e responsável para todos os nossos jogadores. Em caso de dúvidas ou necessidade de suporte adicional, entre em contato conosco através do nosso canal de atendimento:',
		link: {
			title: 'E-mail: ',
			description: `suporte@${choosePlatformDomainName()}`,
			url: `mailto:suporte@${choosePlatformDomainName()}`,
			target: '',
		},
	},
	{
		position: 5,
		title: 'REVISÃO E ATUALIZAÇÃO DA POLÍTICA',
		description:
			'Esta Política de Jogo Responsável será revisada periodicamente para garantir sua eficácia e conformidade com a legislação vigente. Atualizações serão comunicadas aos nossos jogadores através de nossos canais oficiais.',
		description2: `A ${choosePlatformName()} reafirma seu compromisso com o jogo responsável e com a promoção de um ambiente de entretenimento ético e seguro para todos os seus jogadores.`,
	},
];
